import UbsApiV2 from "./UbsApiV2";

export const uploadMemberPhoto = async (memberId, photo) => {
  const headers = {
    "Content-Type": photo.type,
  };
  try {
    const respones = await UbsApiV2.post(
      `/ssc/members/${memberId}/photo`,
      photo,
      {
        headers: headers,
      },
    );
    return respones;
  } catch (error) {
    if (error.response) return error.response;
    return error;
  }
};

export const getMemberPhoto = async (memberId) => {
  const headers = {
    "Content-Type": "application/json",
  };
  const respones = await UbsApiV2.get(`/ssc/members/${memberId}/photo`, {
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
  return respones;
};

export const deleteMemberPhoto = async (memberId) => {
  const headers = {
    "Content-Type": "application/json",
  };
  const respones = await UbsApiV2.delete(`/ssc/members/${memberId}/photo`, {
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      let errRes = {};
      if (err.response !== undefined) {
        errRes = err.response;
      } else {
        errRes = "Network error";
      }
      return errRes;
    });
  return respones;
};
